<!-- Search Template (shared by all headers) -->
<ng-template #searchTemplate>
  <app-search
    [placeholderText]="pageRouteData?.searchBarPh || 'Search'"
    [showFilter]="pageRouteData?.showFilter"
    [showAdd]="pageRouteData?.showAdd"
    [showDownload]="pageRouteData?.showDownload"
    [pageSearch]="pageRouteData?.value"
    [filterType]="pageRouteData?.filterType"
    [segmentSearch]="pageRouteData?.activeSegment"
  ></app-search>
</ng-template>

@if (userData) {
  <ion-header #adminHeader mode="ios" class="admin-header">
    <ion-toolbar mode="ios" color="light" class="admin-header__toolbar">
      @if (pageRouteData?.backButton) {
        <ion-buttons slot="start" class="admin-header__back">
          <ion-button fill="clear" (click)="goBack()" class="admin-header__icon-button" aria-label="Back">
            <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      } @else if (!navigationOpen) {
        <ion-button slot="start" fill="clear" class="admin-header__menu" aria-label="Menu" (click)="navigationToggle.emit()">
          <ion-icon name="menu-outline" slot="icon-only"></ion-icon>
        </ion-button>
      }
      @if (!navigationOpen) {
        <ion-buttons mode="ios" slot="start">
          <ion-button size="small" fill="clear" routerLink="/dashboard" slot="start" tappable class="admin-header__brand-button">
            <img src="/assets/icon/logo.png" width="44" height="44" onError="this.src='/assets/icon/headerlogo.png'" />
            <div class="admin-header__brand-copy">
              <strong>Doskai Admin</strong>
              <span>Control Center</span>
            </div>
          </ion-button>
        </ion-buttons>
      }

      @for (button of pageRouteData?.buttons; track button.route) {
        <ion-buttons mode="ios" slot="end" class="tooltip admin-header__actions">
          <ion-button [routerLink]="button.route" fill="clear" class="admin-header__icon-button">
            <ion-icon size="large" slot="icon-only" name="{{ button.icon }}"></ion-icon>
            @if (button.badge && button.count > 0) {
              <ion-badge color="danger" mode="ios" class="admin-header__action-badge">
                {{ button.count }}
              </ion-badge>
            }
          </ion-button>
          <span class="tooltiptext tooltip-bottom">{{ button.tooltip || "Button" }}</span>
        </ion-buttons>
      }

      @if (pageRouteData?.globalSearch) {
        <ion-buttons mode="ios" slot="end" class="tooltip admin-header__actions">
          <ion-button fill="clear" class="admin-header__icon-button" (click)="openGlobalSearch()" data-testid="global-search-button">
            <ion-icon size="large" slot="icon-only" name="search"></ion-icon>
          </ion-button>
          <span class="tooltiptext tooltip-bottom">Search</span>
        </ion-buttons>
      }

      <ion-buttons mode="ios" slot="end" class="tooltip admin-header__actions">
        <ion-button mode="ios" fill="clear" title="Profile" class="admin-header__profile-button">
          <ion-avatar class="admin-header__avatar">
            <ion-img src="{{ imgsrc }}" (ionError)="loadDefault($event)"></ion-img>
          </ion-avatar>
        </ion-button>
        <span class="tooltiptext tooltip-bottom">Profile</span>
      </ion-buttons>

      <ion-buttons mode="ios" slot="end" class="tooltip admin-header__actions">
        <ion-button mode="ios" fill="clear" title="Settings" tappable (click)="opensettings()" class="admin-header__icon-button">
          <ion-icon name="settings"></ion-icon>
        </ion-button>
        <span class="tooltiptext tooltip-bottom">Settings</span>
        <ion-button mode="ios" slot="end" fill="clear" (click)="changedarkMode()" size="small" class="admin-header__icon-button">
          @if (darkmode) {
            <ion-icon name="sunny"></ion-icon>
          } @else {
            <ion-icon name="moon"></ion-icon>
          }
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <ion-grid class="ion-no-padding admin-header__context">
      <ion-row class="ion-no-padding ion-justify-content-center admin-header__context-row">
        <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0" class="ion-no-padding admin-header__context-spacer"></ion-col>
        <ion-col
          sizeXl="7"
          sizeLg="7"
          sizeMd="10"
          sizeSm="12"
          sizeXs="12"
          class="ion-no-padding admin-header__context-column"
          [class.admin-header__context-column--search]="pageRouteData?.searchBar"
          [class.admin-header__context-column--segment]="pageRouteData?.activeSegment"
        >
          <div class="admin-header__headline">
            <div class="admin-header__headline-copy">
              <h1>{{ pageRouteData?.title || "Admin Console" }}</h1>
              <p>
                @if (pageRouteData?.subtitle) {
                  {{ pageRouteData?.subtitle }}
                } @else if (pageRouteData?.searchBar) {
                  Manage and review this admin area.
                } @else if (pageRouteData?.activeSegment) {
                  Switch between dashboard views.
                } @else {
                  Review and manage platform operations across devices.
                }
              </p>
            </div>
            @if (pageRouteData?.headerMeta?.text) {
              <div class="admin-header__meta" [class.admin-header__meta--warning]="pageRouteData?.headerMeta?.tone === 'warning'">
                @if (pageRouteData?.headerMeta?.icon) {
                  <ion-icon [name]="pageRouteData.headerMeta.icon" aria-hidden="true"></ion-icon>
                }
                <span>{{ pageRouteData.headerMeta.text }}</span>
              </div>
            }
          </div>

          @if (pageRouteData?.activeSegment) {
            <ion-segment
              color="dark"
              mode="md"
              value="{{ pageRouteData.activeSegment }}"
              (ionChange)="segmentChanged($event)"
              class="admin-header__segment"
            >
              @for (segment of pageRouteData.segments; track segment.value) {
                <ion-segment-button mode="md" value="{{ segment.value }}">
                  <ion-label>{{ segment.title }}</ion-label>
                </ion-segment-button>
              }
            </ion-segment>
          }
          @if (pageRouteData?.searchBar) {
            <div class="hide-mobile-xs hide-mobile-sm admin-header__search-desktop">
              <ng-container *ngTemplateOutlet="searchTemplate"></ng-container>
            </div>
            <div class="hide-web-lg hide-web-xl admin-header__search-mobile">
              <ng-container *ngTemplateOutlet="searchTemplate"></ng-container>
            </div>
          }
        </ion-col>
        <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0" class="ion-no-padding admin-header__context-spacer"></ion-col>
      </ion-row>
    </ion-grid>
  </ion-header>
} @else {
  <ion-header #adminHeader mode="ios" class="admin-header">
    <ion-toolbar mode="ios" color="light" class="admin-header__toolbar">
      <ion-button mode="ios" slot="start" size="small" fill="clear" routerLink="/dashboard" tappable class="admin-header__brand-button">
        <img src="/assets/icon/logo.png" width="44" height="44" onError="this.src='/assets/icon/headerlogo.png'" />
        <div class="admin-header__brand-copy">
          <strong>Doskai Admin</strong>
          <span>Admin console</span>
        </div>
      </ion-button>

      <ion-buttons mode="ios" slot="end" class="tooltip admin-header__actions">
        <ion-button mode="ios" slot="end" fill="clear" (click)="changedarkMode()" size="small" class="admin-header__icon-button">
          @if (darkmode) {
            <ion-icon name="sunny"></ion-icon>
          } @else {
            <ion-icon name="moon"></ion-icon>
          }
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
}
